jQuery( document ).ready(function($) {
  if ($(window).width() < 768) {
    $('.product-card .product-size-container .product-size-label').on('click', function () {
      const productSizeWrapperContent = $(this).siblings('.product-size-wrapper').html();

      const closeIcon = '<svg aria-hidden="true" focusable="false" fill="none" width="18" class="icon icon-close icon--direction-aware" style="enable-background:new 0 0 1500 1500;" viewBox="0 0 1500 1500"><style type="text/css"> 	.st0{fill:#FFFFFF;stroke:#4D5E66;stroke-width:40;stroke-miterlimit:10;} </style> <g> 	<line class="st0" x1="351.02" y1="308.85" x2="1145.96" y2="1219.72"/> 	<line class="st0" x1="1184.61" y1="308.85" x2="351.02" y2="1219.72"/> </g></svg>';
      
      const popup = $('<div class="popup">');
      const popupContent = $('<div class="popup-content">');
      const productSizeWrapper = $('<div class="product-size-wrapper">').html(productSizeWrapperContent);
      const closeButton = $('<button class="close-popup">' + closeIcon + '</button>');

      const overlay = $('<div class="popup-overlay"></div>');
      popup.append(overlay);

      popupContent.append(productSizeWrapper);
      popupContent.append(closeButton);
      
      popup.append(popupContent);
      
      $('body').append(popup);
      popup.show();
      
      closeButton.on('click', function () {
        popup.remove();
      });
      
      overlay.on('click', function () {
        popup.remove();
      });
    });
  }
});
